module.exports = __webpack_public_path__ + "img/wxcod.1bbe67bf.png";